import(/* webpackMode: "eager" */ "/home/ubuntu/app/hellojob-pro/src/app/tu-van-vien/[id]/page.tsx");
